(function () {
    'use strict';

    angular
     .module('questionnaireTemplatesEditModule')
     .controller('ODDQuestionnaireTemplateComponentListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'questionnaireTemplate', 'questionnaireSection', 'oddQuestionnaireTemplateService','notificationService'];

    function Controller($scope, $state, topBarService, businessUnit, questionnaireTemplate, questionnaireSection, oddQuestionnaireTemplateService, notificationService) {

        topBarService.setTitleAndIcon('Operational Due Diligence | ' + businessUnit.TitleEN, 'icon icon-clipboard');

        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.questionnaireSection = questionnaireSection;

        $scope.goToQuestionnaireTemplate = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire', {
                ODDQuestionnaireID: questionnaireTemplate.ODDQuestionnaireID
            });
        };

        $scope.goToQuestionnaireSection = function () {
            $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                ODDSectionID: questionnaireSection.ODDSectionID
            }, {
                reload: true
            });
        };

        // Delete StaticText
        $scope.deleteStaticText = function (staticText) {
            oddQuestionnaireTemplateService
             .deleteStaticText(businessUnit.ODDBusinessUnitID,
              questionnaireSection.ODDQuestionnaireID,
              questionnaireSection.ODDSectionID,
              staticText.ODDStaticTextID).then(function () {
                  notificationService.notify('Static Text has been deleted');
                  $state.go('odd.questionnaireTemplatesEdit.questionnaire.section', {
                      ODDSectionID: questionnaireSection.ODDSectionID
                  }, {
                      reload: true
                  });
              });
        };

    }
})();